import React from "react";
import { ToastContainer } from "react-toastify";
import UpdateProduct from "../../components/ProductManager/Product/UpdateProduct";

export const UpdateProductPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <UpdateProduct />
        </div>
      </div>
    </div>
  );
};
